import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { ClientRequests } from './pages';

export const ClientRequestsEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Client Requests',
      element: <ClientRequests />,
      path: '/',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
